import { FORM_EDITOR_HEADER_DISPLAY, FORM_EDITOR_TYPE_MAP } from "./constants";

/**
 * Determines if a header item should be displayed based on the form editor type
 */
export const getHeaderDisplay = (headerType, itemToDisplay, config = {}) => {
  const {
    formEditorType = FORM_EDITOR_TYPE_MAP.DEFAULT,
    excludes = [],
  } = config;

  const headerDisplayMap = FORM_EDITOR_HEADER_DISPLAY[headerType];
  
  if (!headerDisplayMap) {
    return false;
  }

  // Get configuration for the specific item to display
  const currentConfig = headerDisplayMap[itemToDisplay];
  
  if (!currentConfig) {
    return false;
  }

  const { allowed, restricted } = currentConfig;

  // Early return if forcibly excluded or is restricted - most performant check first
  if (excludes.includes(itemToDisplay) || restricted.includes(formEditorType)) {
    return false;
  }
  
  // Check for DEFAULT (universal) type first - common case optimization
  if (allowed.includes(FORM_EDITOR_TYPE_MAP.DEFAULT)) {
    return true;
  }
  
  // Check specific type
  return allowed.includes(formEditorType);
};